import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Prose from "../utility/prose";

const ServiceRate = () => {
    const data = useStaticQuery(graphql`
        query {
            strapiServiceRate {
                service_rates {
                    title
                    rates {
                        id
                        strapi_json_value {
                            type
                            from
                            to
                            rate
                        }
                    }
                }
            }
        }
  `)

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function getRate(rate, key) {
        if(key === 0 && rate.to === -1){
            if(rate.type === "fixed") {
                return `Flat Rate for Service`
            } else if(rate.type === "minimum") {
                return `Minimum Rate for Service`
            } else if(rate.type === "per1K") {
                return `Rate per 1,000 gallons of metered usage`
            } else {
                return `Undefined Rate`
            }
        }

        if(rate.title !== undefined) {
            if(rate.type === "fixed" || rate.type === "tax") {
                return `${rate.title}`
            } else if(rate.type === "per1K") {
                return `Rate per 1,000 gallons of metered usage`
            } else {
                return `Undefined Rate`
            }

        }

        if(rate.type === "per1K") {
            if(rate.to === -1) {
                return `Rate per 1,000 gallons metered for usage above ${numberWithCommas(rate.from)} gallons`
            }
            return `Rate per 1,000 gallons metered for usage between ${numberWithCommas(rate.from)} gallons and ${numberWithCommas(rate.to)} gallons`
        }

        return `Undefined Rate`
    }

    return (
        <div className="mx-auto md:w-3/4 mb-14">
        <Prose>
        <h1 className="text-center">Service Rates:</h1>
        <hr />
        {data.strapiServiceRate.service_rates.map( rate => (
            <>
                <h3>{rate.title}</h3>
                
                <table className="w-full">
                    <tbody>
                    {rate.rates.strapi_json_value.map( (rate, key) => (
                        <tr>
                            {rate.type === "tax" ? (
                                <td style={{textAlign: 'right', width: '100px'}}>{(rate.rate*100).toFixed(2)} %</td>
                            ) : (
                                <td style={{textAlign: 'right', width: '100px'}}>$ {rate.rate.toFixed(2)}</td>
                            )}
                            <td>{getRate(rate, key)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </>
        )
        )}
        </Prose>
        </div>
    )
}

export default ServiceRate